// extracted by mini-css-extract-plugin
module.exports = {"cardRow":"dashboardcardrow_cardRow__2tXKq"};